import { render, staticRenderFns } from "./legal-document-template-view.vue?vue&type=template&id=45f14b6f"
import script from "./legal-document-template-view.vue?vue&type=script&lang=js"
export * from "./legal-document-template-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports